import * as THREE from 'three';
import { InsideType } from '../../../constants/enum';
import { GeometryUtils } from '../../../utils/geometry/GeometryUtils';

export class EdgeDetector {
  //#region NORMAL ROTATION
  static findMeshPoints(group, ignoreXanBa = false, checkXanBa = false) {
    const meshPoints = [];

    const getSize = obj => {
      // Tạo bounding box trong world space
      const worldBox = new THREE.Box3().setFromObject(obj);

      // Lấy kích thước
      const size = new THREE.Vector3();
      worldBox.getSize(size);

      return { box: worldBox, size };
    };

    const processChild = child => {
      const { box, size } = getSize(child);

      let orientation =
        size.y < Math.min(size.x, size.z)
          ? Math.abs(this?.pillar?.position?.z) === 0 &&
            Math.abs(child.position.y - this?.pillar?.position?.y) < 0.02
            ? 4
            : 0
          : size.x < Math.min(size.y, size.z)
            ? 2
            : Math.abs(child.position.z) ===
                  Math.abs(this?.pillar?.position?.z) - 0.017 ||
                Math.abs(child.position.z) ===
                  Math.abs(this?.pillar?.position?.z) + this?.pillar?.size?.z
              ? 4
              : 1;

      if (child.name === 'TAM-DINH-VI-CUA') {
        if(!checkXanBa){
          orientation = 1;
        }else{
          return;
        }
      }

      const worldPosition = new THREE.Vector3();
      child.getWorldPosition(worldPosition);

      const min = box.min;
      const max = box.max;
      const center = new THREE.Vector3();
      box.getCenter(center);

      const boxSize = new THREE.Vector3();
      box.getSize(boxSize);

      child.userData.position = worldPosition;
      const positionCenter = new THREE.Vector3(
        worldPosition.x + boxSize.x / 2,
        worldPosition.y + boxSize.y / 2,
        worldPosition.z - boxSize.z / 2
      );
      child.userData.positionCenter = positionCenter;

      meshPoints.push({
        mX: { min: min.x, org: center.x, max: max.x },
        mZ: { min: min.z, org: center.z, max: max.z },
        mY: { min: min.y, org: center.y, max: max.y },
        mesh: child,
        orientation: orientation,
      });
    };

    // group?.traverse((child) => {
    //   if (child.isMesh) {
    //     processChild(child);
    //   }
    // });

    group?.traverse(child => {
      if (
        child.isMesh &&
        child.parent.userData.type !== InsideType.HPANEL &&
        child.parent.userData.type !== InsideType.VPANEL &&
        child.parent.userData.type !== InsideType.DRAWER &&
        child.parent.userData.type !== InsideType.ACCESSORY_FLIP &&
        child.parent.userData.type !== InsideType.U_DRAWER &&
        child.parent.userData.type !== InsideType.VPANEL2 &&
        child.parent.userData.type !== InsideType.DOOR &&
        child.parent.userData.type !== InsideType.BRACE &&
        child.parent.userData.type !== InsideType.ACCESSORY_SINK &&
        child.parent.userData.type !== InsideType.ACCESSORY_DISH_LOWER &&
        child.parent.userData.type !== InsideType.ACCESSORY_COOKER &&
        child.userData.type !== InsideType.HANDLE &&
        child.parent.userData.type !== InsideType.VCURVE
      ) {
        if (
          child.userData?.name?.includes('BCT') ||
          child.userData?.name?.includes('BCP') ||
          (!ignoreXanBa &&
            checkXanBa &&
            child.userData?.name?.includes('DOOR')) ||
          // child.userData?.name?.includes('DOOR') ||
          child.userData?.name === 'ONG-KHOI-1' ||
          child.userData?.name === 'ONG-KHOI-2' ||
          (!ignoreXanBa && child.userData?.name === 'XAN-1-1') ||
          (!ignoreXanBa && child.userData?.name === 'XAN') ||
          (!ignoreXanBa && child.userData?.name === 'BA') ||
          (!ignoreXanBa && child.userData?.name === 'XAN-1') ||
          (!ignoreXanBa && child.userData?.name === 'BA-1') ||
          child.userData?.name === 'ONG-KHOI-3' ||
          child.userData?.name === 'SINGLE_BACKSPLASH' ||
          child.userData?.name === 'SINGLE_COUNTERTOP'
        )
          return;
        processChild(child);
      }
    });

    group?.traverse(child => {
      if (
        child.isGroup &&
        (child.userData.type === InsideType.DRAWER ||
          child.userData.type === InsideType.ACCESSORY_FLIP ||
          child.userData.type === InsideType.VCURVE ||
          child.userData.type === InsideType.HPANEL ||
          child.userData.type === InsideType.DOOR ||
          child.userData.type === InsideType.U_DRAWER ||
          child.userData.type === InsideType.VPANEL2 ||
          child.userData.type === InsideType.ACCESSORY_DISH_LOWER ||
          child.userData.type === InsideType.VPANEL)
      ) {
        if (child.userData.type === InsideType.DOOR && checkXanBa) return;
        if (child.userData?.isChildUDrawer) return;
        processChild(child);
      }
    });

    return meshPoints;
  }

  static findClosestXEdges(meshPoints, intersection, excludeTypes = []) {
    let backEdge;

    meshPoints.forEach(pt => {
      if (excludeTypes.includes(pt.mesh.userData?.type)) return;

      if (
        intersection.y < pt.mY.max &&
        intersection.y > pt.mY.min &&
        intersection.z < pt.mZ.max &&
        intersection.z > pt.mZ.min &&
        pt.orientation === 2
      ) {
        if (!backEdge || pt.mX.min > backEdge.mX.min) {
          backEdge = pt;
        }
      }
    });

    return backEdge;
  }

  /**
   * Tìm cạnh mặt trước / mặt sau gần nhất theo trục chiều sâu của module.
   * Dùng chung cho mọi orientation (khác với findClosestXEdges* chỉ tìm tấm hậu):
   *  - NORMAL: depthAxis = 'x', frontSign = 1   (mặt trước hướng +X)
   *  - ROTATED_180: depthAxis = 'x', frontSign = -1
   *  - ROTATED_90: depthAxis = 'z', frontSign = -1
   *  - ROTATED_270: depthAxis = 'z', frontSign = 1
   */
  static findClosestFrontBackEdges(
    meshIds,
    meshPoints,
    intersection,
    depthAxis = 'x',
    frontSign = 1,
    excludeTypes = [],
    moveType = null
  ) {
    const depthKey = depthAxis === 'x' ? 'mX' : 'mZ';
    const sideKey = depthAxis === 'x' ? 'mZ' : 'mX';
    const depthValue = depthAxis === 'x' ? intersection.x : intersection.z;
    const sideValue = depthAxis === 'x' ? intersection.z : intersection.x;

    // Cạnh gần nhất về phía dương / phía âm của trục chiều sâu
    let positiveEdge, negativeEdge;

    meshPoints.forEach(pt => {
      if (pt.mesh.visible === false) return;
      if (excludeTypes?.includes(pt.mesh.userData?.type)) return;
      if (meshIds?.includes(pt.mesh.uuid)) return;

      if (
        intersection.y < pt.mY.max &&
        intersection.y > pt.mY.min &&
        sideValue < pt[sideKey].max &&
        sideValue > pt[sideKey].min &&
        (pt.orientation === 2 || pt.orientation === moveType)
      ) {
        if (
          depthValue <= pt[depthKey].min &&
          (!positiveEdge || pt[depthKey].min < positiveEdge[depthKey].min)
        ) {
          positiveEdge = pt;
        } else if (
          depthValue > pt[depthKey].max &&
          (!negativeEdge || pt[depthKey].max > negativeEdge[depthKey].max)
        ) {
          negativeEdge = pt;
        }
      }
    });

    return frontSign > 0
      ? { frontEdge: positiveEdge, backEdge: negativeEdge }
      : { frontEdge: negativeEdge, backEdge: positiveEdge };
  }

  /**
   * Tìm cạnh trái / cạnh phải gần nhất theo trục ngang của module.
   * Dùng chung cho mọi orientation (thay cho findClosestZEdges / R270 / R90):
   *  - NORMAL: sideAxis = 'z', leftSign = 1     (bên trái hướng +Z)
   *  - ROTATED_180: sideAxis = 'z', leftSign = -1
   *  - ROTATED_90: sideAxis = 'x', leftSign = 1
   *  - ROTATED_270: sideAxis = 'x', leftSign = -1
   */
  static findClosestLeftRightEdges(
    meshIds,
    meshPoints,
    intersection,
    sideAxis = 'z',
    leftSign = 1,
    excludeTypes = [],
    moveType = null
  ) {
    const sideKey = sideAxis === 'z' ? 'mZ' : 'mX';
    const sideValue = sideAxis === 'z' ? intersection.z : intersection.x;

    // Cạnh gần nhất về phía dương / phía âm của trục ngang
    let positiveEdge, negativeEdge;

    meshPoints.forEach(pt => {
      if (excludeTypes?.includes(pt.mesh.userData?.type)) return;
      if (meshIds?.includes(pt.mesh.uuid)) return;

      if (
        intersection.y < pt.mY.max &&
        intersection.y > pt.mY.min &&
        (pt.orientation === 1 || pt.orientation === moveType)
      ) {
        if (
          sideValue <= pt[sideKey].min &&
          (!positiveEdge || pt[sideKey].min < positiveEdge[sideKey].min)
        ) {
          positiveEdge = pt;
        } else if (
          sideValue > pt[sideKey].max &&
          (!negativeEdge || pt[sideKey].max > negativeEdge[sideKey].max)
        ) {
          negativeEdge = pt;
        }
      }
    });

    return leftSign > 0
      ? { leftEdge: positiveEdge, rightEdge: negativeEdge }
      : { leftEdge: negativeEdge, rightEdge: positiveEdge };
  }

  static findClosestYEdges(
    meshIds,
    meshPoints,
    intersection,
    excludeTypes = [],
    moveType = null,
    ignoreTypes = false,
    typeHau
  ) {
    let topEdge, bottomEdge;
    let foundDayMHM = false;

    meshPoints.forEach(pt => {
      if (pt.mesh.visible === false) return;
      if (excludeTypes?.includes(pt.mesh.userData?.type)) return;

      if (
        pt.mesh.name.includes('NEP') &&
        !pt.mesh.name.includes('NEP-NOC') &&
        !pt.mesh.name.includes('NEP-TRUOC') &&
        !typeHau
      )
        return;

      if (pt.mesh.name.includes('DAY-MHM')) {
        foundDayMHM = true;
        return;
      }

      if (
        !meshIds?.includes(pt.mesh.uuid) &&
        intersection.z <= pt.mZ.max &&
        intersection.z > pt.mZ.min &&
        (pt.orientation === 0 ||
          // (pt.orientation === 2 && !ignoreTypes) ||
          (pt.orientation === 2 && (!ignoreTypes || foundDayMHM)) ||
          pt.orientation === moveType)
      ) {
        if (
          intersection.y < pt.mY.min &&
          (!topEdge || pt.mY.min < topEdge.mY.min)
        ) {
          topEdge = pt;
        } else if (
          intersection.y > pt.mY.max &&
          (!bottomEdge || pt.mY.max > bottomEdge.mY.max)
        ) {
          bottomEdge = pt;
        }
      }
    });

    return { topEdge, bottomEdge };
  }

  static findClosestYEdgesDistance(
    meshIds,
    meshPoints,
    intersection,
    excludeTypes = [],
    moveType = null,
    ignoreTypes = false,
    typeHau
  ) {
    let topEdge, bottomEdge;
    let foundDayMHM = false;

    meshPoints.forEach(pt => {
      if (pt.mesh.visible === false) return;
      if (excludeTypes?.includes(pt.mesh.userData?.type)) return;

      if (
        pt.mesh.name.includes('NEP') &&
        !pt.mesh.name.includes('NEP-NOC') &&
        !typeHau
      )
        return;

      if (pt.mesh.name.includes('DAY-MHM')) {
        foundDayMHM = true;
        return;
      }

      if (
        !meshIds?.includes(pt.mesh.uuid) &&
        intersection.z <= pt.mZ.max &&
        intersection.z > pt.mZ.min &&
        intersection.x <= pt.mX.max &&
        intersection.x > pt.mX.min &&
        (pt.orientation === 0 ||
          // (pt.orientation === 2 && !ignoreTypes) ||
          (pt.orientation === 2 && (!ignoreTypes || foundDayMHM)) ||
          pt.orientation === moveType)
      ) {
        if (
          intersection.y < pt.mY.min &&
          (!topEdge || pt.mY.min < topEdge.mY.min)
        ) {
          topEdge = pt;
        } else if (
          intersection.y > pt.mY.max &&
          (!bottomEdge || pt.mY.max > bottomEdge.mY.max)
        ) {
          bottomEdge = pt;
        }
      }
    });

    return { topEdge, bottomEdge };
  }
  static findClosestYEdgesForDrawer(
    meshIds,
    meshPoints,
    intersection,
    excludeTypes = [],
    moveType = null,
    ignoreTypes = false,
    typeHau
  ) {
    let topEdge, bottomEdge;
    let foundDayMHM = false;

    meshPoints.forEach(pt => {
      if (pt.mesh.visible === false) return;
      if (excludeTypes?.includes(pt.mesh.userData?.type)) return;

      if (
        pt.mesh.name.includes('NEP') &&
        !pt.mesh.name.includes('NEP-NOC') &&
        !typeHau
      )
        return;

      if (pt.mesh.name.includes('DAY-MHM')) {
        foundDayMHM = true;
        return;
      }

      if (
        !meshIds?.includes(pt.mesh.uuid) &&
        (pt.orientation === 0 ||
          // (pt.orientation === 2 && !ignoreTypes) ||
          (pt.orientation === 2 && (!ignoreTypes || foundDayMHM)) ||
          pt.orientation === moveType)
      ) {
        if (
          intersection.y < pt.mY.min &&
          (!topEdge || pt.mY.min < topEdge.mY.min)
        ) {
          topEdge = pt;
        } else if (
          intersection.y > pt.mY.max &&
          (!bottomEdge || pt.mY.max > bottomEdge.mY.max)
        ) {
          bottomEdge = pt;
        }
      }
    });

    return { topEdge, bottomEdge };
  }

  static findClosestZEdges(
    meshIds,
    meshPoints,
    intersection,
    excludeTypes = [],
    moveType = null
  ) {
    let leftEdge, rightEdge;

    meshPoints.forEach(pt => {
      if (excludeTypes?.includes(pt.mesh.userData?.type)) return;

      if (
        !meshIds?.includes(pt.mesh.uuid) &&
        intersection.y < pt.mY.max &&
        intersection.y > pt.mY.min &&
        (pt.orientation === 1 || pt.orientation === moveType)
      ) {
        if (
          intersection.z <= pt.mZ.min &&
          (!leftEdge || pt.mZ.min < leftEdge.mZ.min)
        ) {
          leftEdge = pt;
        } else if (
          intersection.z > pt.mZ.max &&
          (!rightEdge || pt.mZ.max > rightEdge.mZ.max)
        ) {
          rightEdge = pt;
        }
      }
    });

    return { leftEdge, rightEdge };
  }

  static findDrawerClick(meshPoints, intersection) {
    let drawer = null;

    meshPoints.forEach(pt => {
      if (
        pt.mesh.userData?.isInside === true &&
        (pt.mesh.userData?.type === InsideType.DRAWER ||
          pt.mesh.userData?.type === InsideType.U_DRAWER ||
          pt.mesh.userData?.type === InsideType.ACCESSORY_DISH_LOWER)
      ) {
        if (
          intersection.y < pt.mY.max &&
          intersection.y > pt.mY.min &&
          intersection.z < pt.mZ.max &&
          intersection.z > pt.mZ.min
        ) {
          drawer = pt;
        }
      } else {
        return;
      }
    });

    return drawer;
  }

  static findAccessoryFlipClick(meshPoints, intersection) {
    let drawer = null;

    meshPoints.forEach(pt => {
      if (
        pt.mesh.userData?.isInside === true &&
        pt.mesh.userData?.type === InsideType.ACCESSORY_FLIP
      ) {
        if (
          intersection.y < pt.mY.max &&
          intersection.y > pt.mY.min &&
          intersection.z < pt.mZ.max &&
          intersection.z > pt.mZ.min
        ) {
          drawer = pt;
        }
      } else {
        return;
      }
    });

    return drawer;
  }

  static findClosestEdgesForDoor(
    meshIds,
    meshPoints,
    intersection,
    excludeTypes = [],
    moveType = null
  ) {
    let leftEdge, rightEdge;

    meshPoints.forEach(pt => {
      if (excludeTypes?.includes(pt.mesh.userData?.type)) return;

      if (
        !meshIds?.includes(pt.mesh.uuid) &&
        intersection.y < pt.mY.max &&
        intersection.y > pt.mY.min &&
        (pt.orientation === 1 ||
          pt.orientation === 2 ||
          pt.orientation === moveType)
      ) {
        if (
          intersection.z < pt.mZ.min &&
          (!leftEdge || pt.mZ.min < leftEdge.mZ.min)
        ) {
          leftEdge = pt;
        } else if (
          intersection.z > pt.mZ.max &&
          (!rightEdge || pt.mZ.max > rightEdge.mZ.max)
        ) {
          rightEdge = pt;
        }
      }
    });

    return { leftEdge, rightEdge };
  }
  //#endregion

  //#region ROTATION 270
  static findMeshPointsRotation(
    group,
    ignoreXanBa = false,
    checkXanBa = false
  ) {
    const meshPoints = [];

    const getSize = obj => {
      // Tạo bounding box trong world space
      const worldBox = new THREE.Box3().setFromObject(obj);

      // Lấy kích thước
      const size = new THREE.Vector3();
      worldBox.getSize(size);

      return { box: worldBox, size };
    };

    const processChild = child => {
      const { box, size } = getSize(child);

      let orientation =
        size.y < Math.min(size.x, size.z)
          ? Math.abs(this?.pillar?.position?.z) === 0 &&
            Math.abs(child.position.y - this?.pillar?.position?.y) < 0.02
            ? 4
            : 0
          : size.z < Math.min(size.y, size.x)
            ? 2
            : Math.abs(child.position.z) ===
                  Math.abs(this?.pillar?.position?.z) - 0.017 ||
                Math.abs(child.position.z) ===
                  Math.abs(this?.pillar?.position?.z) + this?.pillar?.size?.z
              ? 4
              : 1;

        if (child.name === 'TAM-DINH-VI-CUA') {
        if(!checkXanBa){
          orientation = 1;
        }else{
          return;
        }
      }

      const worldPosition = new THREE.Vector3();
      child.getWorldPosition(worldPosition);

      const min = box.min;
      const max = box.max;
      const center = new THREE.Vector3();
      box.getCenter(center);

      const boxSize = new THREE.Vector3();
      box.getSize(boxSize);

      child.userData.position = worldPosition;
      const positionCenter = new THREE.Vector3(
        worldPosition.x + boxSize.x / 2,
        worldPosition.y + boxSize.y / 2,
        worldPosition.z - boxSize.z / 2
      );
      child.userData.positionCenter = positionCenter;

      meshPoints.push({
        mX: { min: min.x, org: center.x, max: max.x },
        mZ: { min: min.z, org: center.z, max: max.z },
        mY: { min: min.y, org: center.y, max: max.y },
        mesh: child,
        orientation: orientation,
      });
    };

    // group?.traverse((child) => {
    //   if (child.isMesh) {
    //     processChild(child);
    //   }
    // });

    group?.traverse(child => {
      if (
        child.isMesh &&
        child.parent.userData.type !== InsideType.HPANEL &&
        child.parent.userData.type !== InsideType.VPANEL &&
        child.parent.userData.type !== InsideType.DRAWER &&
        child.parent.userData.type !== InsideType.ACCESSORY_FLIP &&
        child.parent.userData.type !== InsideType.U_DRAWER &&
        child.parent.userData.type !== InsideType.DOOR &&
        child.parent.userData.type !== InsideType.BRACE &&
        child.parent.userData.type !== InsideType.VPANEL2 &&
        child.userData.type !== InsideType.HANDLE &&
        child.parent.userData.type !== InsideType.VCURVE
      ) {
        if (
          child.userData?.name?.includes('BCT') ||
          child.userData?.name?.includes('BCP') ||
          // child.userData?.name?.includes('DOOR') ||
          (!ignoreXanBa &&
            checkXanBa &&
            child.userData?.name?.includes('DOOR')) ||
          child.userData?.name === 'ONG-KHOI-1' ||
          child.userData?.name === 'ONG-KHOI-2' ||
          (!ignoreXanBa && child.userData?.name === 'XAN-1-1') ||
          (!ignoreXanBa && child.userData?.name === 'XAN') ||
          (!ignoreXanBa && child.userData?.name === 'BA') ||
          (!ignoreXanBa && child.userData?.name === 'XAN-1') ||
          (!ignoreXanBa && child.userData?.name === 'BA-1') ||
          child.userData?.name === 'ONG-KHOI-3' ||
          child.userData?.name === 'SINGLE_BACKSPLASH' ||
          child.userData?.name === 'SINGLE_COUNTERTOP'
        )
          return;
        processChild(child);
      }
    });

    group?.traverse(child => {
      if (
        child.isGroup &&
        (child.userData.type === InsideType.DRAWER ||
          child.userData.type === InsideType.VCURVE ||
          child.userData.type === InsideType.ACCESSORY_FLIP ||
          child.userData.type === InsideType.HPANEL ||
          child.userData.type === InsideType.U_DRAWER ||
          child.userData.type === InsideType.DOOR ||
          child.userData.type === InsideType.VPANEL2 ||
          child.userData.type === InsideType.VPANEL)
      ) {
        if (child.userData.type === InsideType.DOOR && checkXanBa) return;
        if (child.userData?.isChildUDrawer) return;
        processChild(child);
      }
    });

    return meshPoints;
  }
  static findDrawerClickR270(meshPoints, intersection) {
    let drawer = null;

    meshPoints.forEach(pt => {
      if (
        pt.mesh.userData?.type === InsideType.DRAWER ||
        pt.mesh.userData?.type === InsideType.U_DRAWER ||
        pt.mesh.userData?.type === InsideType.ACCESSORY_DISH_LOWER
      ) {
        if (
          intersection.y < pt.mY.max &&
          intersection.y > pt.mY.min &&
          intersection.x < pt.mX.max &&
          intersection.x > pt.mX.min
        ) {
          drawer = pt;
        }
      } else {
        return;
      }
    });

    return drawer;
  }
  static findAccessoryFlipClickR270(meshPoints, intersection) {
    let drawer = null;

    meshPoints.forEach(pt => {
      if (pt.mesh.userData?.type === InsideType.ACCESSORY_FLIP) {
        if (
          intersection.y < pt.mY.max &&
          intersection.y > pt.mY.min &&
          intersection.x < pt.mX.max &&
          intersection.x > pt.mX.min
        ) {
          drawer = pt;
        }
      } else {
        return;
      }
    });

    return drawer;
  }

  static findClosestXEdgesR270(meshPoints, intersection, excludeTypes = []) {
    let backEdge;

    meshPoints.forEach(pt => {
      if (excludeTypes.includes(pt.mesh.userData?.type)) return;

      if (
        intersection.y < pt.mY.max &&
        intersection.y > pt.mY.min &&
        intersection.x < pt.mX.max &&
        intersection.x > pt.mX.min &&
        pt.orientation === 2
      ) {
        if (!backEdge || pt.mZ.min > backEdge.mZ.min) {
          backEdge = pt;
        }
      }
    });

    return backEdge;
  }

  static findClosestYEdgesR270(
    meshIds,
    meshPoints,
    intersection,
    excludeTypes = [],
    moveType = null,
    ignoreTypes = false
  ) {
    let topEdge, bottomEdge;

    meshPoints.forEach(pt => {
      if (pt.mesh.visible === false) return;
      if (excludeTypes?.includes(pt.mesh.userData?.type)) return;

      if (
        !meshIds?.includes(pt.mesh.uuid) &&
        intersection.x < pt.mX.max &&
        intersection.x > pt.mX.min &&
        (pt.orientation === 0 ||
          (pt.orientation === 2 && !ignoreTypes) ||
          pt.orientation === moveType)
      ) {
        if (
          intersection.y < pt.mY.min &&
          (!topEdge || pt.mY.min < topEdge.mY.min)
        ) {
          topEdge = pt;
        } else if (
          intersection.y > pt.mY.max &&
          (!bottomEdge || pt.mY.max > bottomEdge.mY.max)
        ) {
          bottomEdge = pt;
        }
      }
    });

    return { topEdge, bottomEdge };
  }

  static findClosestYEdgesR270Distance(
    meshIds,
    meshPoints,
    intersection,
    excludeTypes = [],
    moveType = null,
    ignoreTypes = false
  ) {
    let topEdge, bottomEdge;

    meshPoints.forEach(pt => {
      if (pt.mesh.visible === false) return;
      if (excludeTypes?.includes(pt.mesh.userData?.type)) return;

      if (
        !meshIds?.includes(pt.mesh.uuid) &&
        intersection.z < pt.mZ.max &&
        intersection.z > pt.mZ.min &&
        (pt.orientation === 0 ||
          (pt.orientation === 2 && !ignoreTypes) ||
          pt.orientation === moveType)
      ) {
        if (
          intersection.y < pt.mY.min &&
          (!topEdge || pt.mY.min < topEdge.mY.min)
        ) {
          topEdge = pt;
        } else if (
          intersection.y > pt.mY.max &&
          (!bottomEdge || pt.mY.max > bottomEdge.mY.max)
        ) {
          bottomEdge = pt;
        }
      }
    });

    return { topEdge, bottomEdge };
  }

  static findClosestZEdgesR270(
    meshIds,
    meshPoints,
    intersection,
    excludeTypes = [],
    moveType = null
  ) {
    let leftEdge, rightEdge;

    meshPoints.forEach(pt => {
      if (excludeTypes?.includes(pt.mesh.userData?.type)) return;

      if (
        !meshIds?.includes(pt.mesh.uuid) &&
        intersection.y < pt.mY.max &&
        intersection.y > pt.mY.min &&
        (pt.orientation === 1 || pt.orientation === moveType)
      ) {
        if (
          intersection.x > pt.mX.min &&
          (!leftEdge || pt.mX.min > leftEdge.mX.min)
        ) {
          leftEdge = pt;
        } else if (
          intersection.x < pt.mX.max &&
          (!rightEdge || pt.mX.max < rightEdge.mX.max)
        ) {
          rightEdge = pt;
        }
      }
    });

    return { leftEdge, rightEdge };
  }

  static findClosestEdgesForDoorR270(
    meshIds,
    meshPoints,
    intersection,
    excludeTypes = [],
    moveType = null
  ) {
    let leftEdge, rightEdge;

    meshPoints.forEach(pt => {
      if (excludeTypes?.includes(pt.mesh.userData?.type)) return;

      if (
        !meshIds?.includes(pt.mesh.uuid) &&
        intersection.y < pt.mY.max &&
        intersection.y > pt.mY.min &&
        (pt.orientation === 1 ||
          pt.orientation === 2 ||
          pt.orientation === moveType)
      ) {
        if (
          intersection.x > pt.mX.max &&
          (!leftEdge || pt.mX.max > leftEdge.mX.max)
        ) {
          leftEdge = pt;
        } else if (
          intersection.x < pt.mX.min &&
          (!rightEdge || pt.mX.min < rightEdge.mX.min)
        ) {
          rightEdge = pt;
        }
      }
    });

    return { leftEdge, rightEdge };
  }
  //#endregion

  //#region ROTATION 90
  static findMeshPointsR90(group, ignoreXanBa = false, checkXanBa = false) {
    const meshPoints = [];

    const getSize = obj => {
      const worldBox = new THREE.Box3().setFromObject(obj);
      const size = new THREE.Vector3();
      worldBox.getSize(size);
      return { box: worldBox, size };
    };

    const processChild = child => {
      const { box, size } = getSize(child);

      // 90° = đối xứng với 270°, logic orientation giữ nguyên
      let orientation =
        size.y < Math.min(size.x, size.z)
          ? Math.abs(this?.pillar?.position?.z) === 0 &&
            Math.abs(child.position.y - this?.pillar?.position?.y) < 0.02
            ? 4
            : 0
          : size.z < Math.min(size.y, size.x)
            ? 2
            : Math.abs(child.position.z) ===
                  Math.abs(this?.pillar?.position?.z) - 0.017 ||
                Math.abs(child.position.z) ===
                  Math.abs(this?.pillar?.position?.z) + this?.pillar?.size?.z
              ? 4
              : 1;

      if (child.name === 'TAM-DINH-VI-CUA') {
        if(!checkXanBa){
          orientation = 1;
        }else{
          return;
        }
      }

      const worldPosition = new THREE.Vector3();
      child.getWorldPosition(worldPosition);

      const min = box.min;
      const max = box.max;
      const center = new THREE.Vector3();
      box.getCenter(center);

      const boxSize = new THREE.Vector3();
      box.getSize(boxSize);

      child.userData.position = worldPosition;
      const positionCenter = new THREE.Vector3(
        worldPosition.x + boxSize.x / 2,
        worldPosition.y + boxSize.y / 2,
        worldPosition.z - boxSize.z / 2
      );
      child.userData.positionCenter = positionCenter;

      meshPoints.push({
        mX: { min: min.x, org: center.x, max: max.x },
        mZ: { min: min.z, org: center.z, max: max.z },
        mY: { min: min.y, org: center.y, max: max.y },
        mesh: child,
        orientation: orientation,
      });
    };

    group?.traverse(child => {
      if (
        child.isMesh &&
        child.parent.userData.type !== InsideType.HPANEL &&
        child.parent.userData.type !== InsideType.VPANEL &&
        child.parent.userData.type !== InsideType.DRAWER &&
        child.parent.userData.type !== InsideType.ACCESSORY_FLIP &&
        child.parent.userData.type !== InsideType.U_DRAWER &&
        child.parent.userData.type !== InsideType.DOOR &&
        child.parent.userData.type !== InsideType.ACCESSORY_DISH_LOWER &&
        child.parent.userData.type !== InsideType.BRACE &&
        child.parent.userData.type !== InsideType.VPANEL2 &&
        child.userData.type !== InsideType.HANDLE &&
        child.parent.userData.type !== InsideType.VCURVE
      ) {
        if (
          child.userData?.name?.includes('BCT') ||
          child.userData?.name?.includes('BCP') ||
          // child.userData?.name?.includes('DOOR') ||
          (!ignoreXanBa &&
            checkXanBa &&
            child.userData?.name?.includes('DOOR')) ||
          child.userData?.name === 'ONG-KHOI-1' ||
          child.userData?.name === 'ONG-KHOI-2' ||
          (!ignoreXanBa && child.userData?.name === 'XAN-1-1') ||
          (!ignoreXanBa && child.userData?.name === 'XAN') ||
          (!ignoreXanBa && child.userData?.name === 'BA') ||
          (!ignoreXanBa && child.userData?.name === 'XAN-1') ||
          (!ignoreXanBa && child.userData?.name === 'BA-1') ||
          child.userData?.name === 'ONG-KHOI-3' ||
          child.userData?.name === 'SINGLE_BACKSPLASH' ||
          child.userData?.name === 'SINGLE_COUNTERTOP'
        )
          return;
        processChild(child);
      }
    });

    group?.traverse(child => {
      if (
        child.isGroup &&
        (child.userData.type === InsideType.DRAWER ||
          child.userData.type === InsideType.VCURVE ||
          child.userData.type === InsideType.ACCESSORY_FLIP ||
          child.userData.type === InsideType.HPANEL ||
          child.userData.type === InsideType.U_DRAWER ||
          child.userData.type === InsideType.DOOR ||
          child.userData.type === InsideType.VPANEL2 ||
          child.userData.type === InsideType.ACCESSORY_DISH_LOWER ||
          child.userData.type === InsideType.VPANEL)
      ) {
        if (child.userData.type === InsideType.DOOR && checkXanBa) return;
        if (child.userData?.isChildUDrawer) return;
        processChild(child);
      }
    });

    return meshPoints;
  }

  static findDrawerClickR90(meshPoints, intersection) {
    let drawer = null;

    meshPoints.forEach(pt => {
      if (
        pt.mesh.userData?.type === InsideType.DRAWER ||
        pt.mesh.userData?.type === InsideType.U_DRAWER ||
        pt.mesh.userData?.type === InsideType.ACCESSORY_DISH_LOWER
      ) {
        if (
          intersection.y < pt.mY.max &&
          intersection.y > pt.mY.min &&
          intersection.x < pt.mX.max && // Giống R270 — vẫn dùng trục X
          intersection.x > pt.mX.min
        ) {
          drawer = pt;
        }
      } else {
        return;
      }
    });

    return drawer;
  }

  static findAccessoryFlipClickR90(meshPoints, intersection) {
    let drawer = null;

    meshPoints.forEach(pt => {
      if (pt.mesh.userData?.type === InsideType.ACCESSORY_FLIP) {
        if (
          intersection.y < pt.mY.max &&
          intersection.y > pt.mY.min &&
          intersection.x < pt.mX.max &&
          intersection.x > pt.mX.min
        ) {
          drawer = pt;
        }
      } else {
        return;
      }
    });

    return drawer;
  }

  // Back edge: 90° đối xứng 270° → chiều mZ.min đảo thành mZ.max
  static findClosestXEdgesR90(meshPoints, intersection, excludeTypes = []) {
    let backEdge;

    meshPoints.forEach(pt => {
      if (excludeTypes.includes(pt.mesh.userData?.type)) return;

      if (
        intersection.y < pt.mY.max &&
        intersection.y > pt.mY.min &&
        intersection.x < pt.mX.max &&
        intersection.x > pt.mX.min &&
        pt.orientation === 2
      ) {
        // 270° lấy pt.mZ.min lớn nhất → 90° đối xứng: lấy pt.mZ.max nhỏ nhất
        if (!backEdge || pt.mZ.max < backEdge.mZ.max) {
          backEdge = pt;
        }
      }
    });

    return backEdge;
  }

  // Top/Bottom: vẫn dùng trục X để check, trục Y để so sánh — giống R270
  static findClosestYEdgesR90(
    meshIds,
    meshPoints,
    intersection,
    excludeTypes = [],
    moveType = null,
    ignoreTypes = false
  ) {
    let topEdge, bottomEdge;

    meshPoints.forEach(pt => {
      if (pt.mesh.visible === false) return;
      if (excludeTypes?.includes(pt.mesh.userData?.type)) return;

      if (
        !meshIds?.includes(pt.mesh.uuid) &&
        intersection.x < pt.mX.max &&
        intersection.x > pt.mX.min &&
        (pt.orientation === 0 ||
          (pt.orientation === 2 && !ignoreTypes) ||
          pt.orientation === moveType)
      ) {
        if (
          intersection.y < pt.mY.min &&
          (!topEdge || pt.mY.min < topEdge.mY.min)
        ) {
          topEdge = pt;
        } else if (
          intersection.y > pt.mY.max &&
          (!bottomEdge || pt.mY.max > bottomEdge.mY.max)
        ) {
          bottomEdge = pt;
        }
      }
    });

    return { topEdge, bottomEdge };
  }
  static findClosestYEdgesR90ForDrawer(
    meshIds,
    meshPoints,
    intersection,
    excludeTypes = [],
    moveType = null,
    ignoreTypes = false
  ) {
    let topEdge, bottomEdge;

    meshPoints.forEach(pt => {
      if (pt.mesh.visible === false) return;
      if (excludeTypes?.includes(pt.mesh.userData?.type)) return;

      if (
        !meshIds?.includes(pt.mesh.uuid) &&
        (pt.orientation === 0 ||
          (pt.orientation === 2 && !ignoreTypes) ||
          pt.orientation === moveType)
      ) {
        if (
          intersection.y < pt.mY.min &&
          (!topEdge || pt.mY.min < topEdge.mY.min)
        ) {
          topEdge = pt;
        } else if (
          intersection.y > pt.mY.max &&
          (!bottomEdge || pt.mY.max > bottomEdge.mY.max)
        ) {
          bottomEdge = pt;
        }
      }
    });

    return { topEdge, bottomEdge };
  }

  // Left/Right: 90° đối xứng 270° → đảo chiều so sánh mX
  static findClosestZEdgesR90(
    meshIds,
    meshPoints,
    intersection,
    excludeTypes = [],
    moveType = null
  ) {
    let leftEdge, rightEdge;

    meshPoints.forEach(pt => {
      if (excludeTypes?.includes(pt.mesh.userData?.type)) return;

      if (
        !meshIds?.includes(pt.mesh.uuid) &&
        intersection.y < pt.mY.max &&
        intersection.y > pt.mY.min &&
        (pt.orientation === 1 || pt.orientation === moveType)
      ) {
        // 270°: leftEdge khi intersection.x > pt.mX.min → lấy mX.min lớn nhất
        // 90° (đối xứng):  leftEdge khi intersection.x < pt.mX.max → lấy mX.max nhỏ nhất
        if (
          intersection.x < pt.mX.max &&
          (!leftEdge || pt.mX.max < leftEdge.mX.max)
        ) {
          leftEdge = pt;
        } else if (
          intersection.x > pt.mX.min &&
          (!rightEdge || pt.mX.min > rightEdge.mX.min)
        ) {
          rightEdge = pt;
        }
      }
    });

    return { leftEdge, rightEdge };
  }

  // Door edges: 90° đối xứng 270°
  static findClosestEdgesForDoorR90(
    meshIds,
    meshPoints,
    intersection,
    excludeTypes = [],
    moveType = null
  ) {
    let leftEdge, rightEdge;

    meshPoints.forEach(pt => {
      if (excludeTypes?.includes(pt.mesh.userData?.type)) return;

      if (
        !meshIds?.includes(pt.mesh.uuid) &&
        intersection.y < pt.mY.max &&
        intersection.y > pt.mY.min &&
        (pt.orientation === 1 ||
          pt.orientation === 2 ||
          pt.orientation === moveType)
      ) {
        // 270°: leftEdge khi intersection.x > pt.mX.max → lấy mX.max lớn nhất
        // 90° (đối xứng):  leftEdge khi intersection.x < pt.mX.min → lấy mX.min nhỏ nhất
        if (
          intersection.x < pt.mX.min &&
          (!leftEdge || pt.mX.min < leftEdge.mX.min)
        ) {
          leftEdge = pt;
        } else if (
          intersection.x > pt.mX.max &&
          (!rightEdge || pt.mX.max > rightEdge.mX.max)
        ) {
          rightEdge = pt;
        }
      }
    });

    return { leftEdge, rightEdge };
  }
  //#endregion

  static getSizeFromObject(obj) {
    const box = new THREE.Box3().setFromObject(obj);
    const size = new THREE.Vector3();
    box.getSize(size);
    return size;
  }

  static findEdgeMeshes(insideGltf, clonedModule) {
    const userData = insideGltf.userData || {};
    const edges = {};

    // Tìm left và right edges cho xà ngang
    if (userData.leftEdgeUuid) {
      edges.leftEdge = GeometryUtils.findMeshByUuid(
        clonedModule.group,
        userData.leftEdgeUuid
      );
    }

    if (userData.rightEdgeUuid) {
      edges.rightEdge = GeometryUtils.findMeshByUuid(
        clonedModule.group,
        userData.rightEdgeUuid
      );
    }

    // Tìm top và bottom edges cho xà dọc
    if (userData.topEdgeUuid) {
      edges.topEdge = GeometryUtils.findMeshByUuid(
        clonedModule.group,
        userData.topEdgeUuid
      );
    }

    if (userData.bottomEdgeUuid) {
      edges.bottomEdge = GeometryUtils.findMeshByUuid(
        clonedModule.group,
        userData.bottomEdgeUuid
      );
    }

    //Bổ sung cho cửa
    if (userData.leftEdgeDoorUuid) {
      edges.leftEdgeDoor = GeometryUtils.findMeshByUuid(
        clonedModule.group,
        userData.leftEdgeDoorUuid
      );
    }

    if (userData.rightEdgeDoorUuid) {
      edges.rightEdgeDoor = GeometryUtils.findMeshByUuid(
        clonedModule.group,
        userData.rightEdgeDoorUuid
      );
    }

    return edges;
  }
}
